import {
  automationSharesUrl,
  automationShareUrl,
} from "../constants/automation-api-urls";
import type {
  IAutomationShare,
  IAutomationSharesListResponse,
  IAutomationShareTarget,
  IRemoveAutomationShareProps,
  IShareAutomationProps,
  IUpdateAutomationShareProps,
} from "../types";
import type { ApiClient } from "./client";

// NOTE: NSAI-5272 — point-to-point sharing of scheduled tasks and webhooks.
// Every route is gated server-side: only the automation's owner administers its
// shares, and a recipient may remove their own share to leave.
export class AutomationShareApi {
  constructor(private readonly apiClient: ApiClient) {}

  async getShares(
    target: IAutomationShareTarget,
  ): Promise<IAutomationSharesListResponse> {
    const response = await this.apiClient.get<IAutomationSharesListResponse>(
      automationSharesUrl(target),
    );
    return response.data;
  }

  async share({
    automationType,
    automationUuid,
    data,
  }: IShareAutomationProps): Promise<IAutomationShare[]> {
    const response = await this.apiClient.post<IAutomationShare[]>(
      automationSharesUrl({ automationType, automationUuid }),
      data,
    );
    return response.data;
  }

  async updateShare({
    automationType,
    automationUuid,
    shareUuid,
    data,
  }: IUpdateAutomationShareProps): Promise<IAutomationShare> {
    const response = await this.apiClient.put<IAutomationShare>(
      automationShareUrl({ automationType, automationUuid, shareUuid }),
      data,
    );
    return response.data;
  }

  async removeShare(props: IRemoveAutomationShareProps): Promise<void> {
    await this.apiClient.delete(automationShareUrl(props));
  }
}
